import { useRouter } from "next/router";
import PatientWiseTest from "@/src/modules/cart/confirm-test/patientWiseTest";
import IconCode from "@/src/lib/iconCode";
import Iconify from "../../iconify";
import CustomIconButton from "@/src/lib/ui/iconButton";
import CustomTooltip from "@/src/lib/ui/customTooltip";

const ShowCartVisitWise = ({
    heading,
    visitWise,
    refetchCheckoutData,
    checkoutData,
    isCentreCart = false,
    handleClose,
}) => {
    const router = useRouter();
    const centreCart = checkoutData?.data?.data?.centreCart?.data?.[0];
    const homeCart = checkoutData?.data?.data?.homeCart?.data?.[0];

    const renderCurrentCentre = (
        <div className="flex items-center  bg-gray-50 p-3 rounded-md ">
            <p className="font-semibold text-primary text-[14px]">
                Visiting:{" "}
            </p>
            <p
                className="font-semibold text-[#1C252E] cursor-pointer ml-1 text-[14px]"
                onClick={() => {
                    router.push(`/${centreCart?.visitLocation?.centreSlug}`);
                    handleClose();
                }}
            >
                HOD{" "}
                {centreCart?.visitLocation?.centre.replace("HOD ", "") ||
                    "Centre Name Unavailable"}
            </p>
            <CustomTooltip title="View Centre">
                <CustomIconButton
                    onClick={() => {
                        router.push(
                            `/${centreCart?.visitLocation?.centreSlug}`
                        );
                        handleClose();
                    }}
                >
                    <Iconify
                        icon={"ri:direction-fill"}
                        width={20}
                        className="text-primary"
                    />
                </CustomIconButton>
            </CustomTooltip>
        </div>
    );
    const renderHomeAddress = (
        <div className="flex items-center  bg-gray-50 p-3 mb-2 rounded-md ">
            <p className="font-semibold text-primary text-[14px]">
                Collecting From:{" "}
            </p>
            <p
                className="font-semibold text-[#1C252E] cursor-pointer ml-1 text-[14px]"
            >
                {`${homeCart?.visitLocation?.pincode}`}
            </p>
            <CustomTooltip title="Edit">
                <CustomIconButton
                    onClick={() => {
                        router.push(`/cart`);
                        handleClose();
                    }}
                >
                    <Iconify
                        icon={IconCode.edit}
                        width={20}
                        className="text-primary"
                    />
                </CustomIconButton>
            </CustomTooltip>
        </div>
    );
    return (
        visitWise?.data?.[0]?.patients?.length > 0 && (
            <>
                <h4 className="text-primary font-bold text-base mb-3">
                    {heading}
                </h4>
                {/* {
                    visitWise?.data?.[0]?.patients?.length > 0 && (

                    )
                } */}
                {isCentreCart ? renderCurrentCentre : renderHomeAddress}
                {visitWise?.data?.[0]?.patients?.map((patient, index) => {
                    return (
                        <PatientWiseTest
                            key={index} // Use a unique key
                            cartItems={patient}
                            refetchCheckoutData={refetchCheckoutData}
                            productandPatientName="text-sm"
                            innerContainer="p-2"
                            paddingContainer="px-2 py-1"
                            priceText="text-base"
                            iconwidth={16}
                            ruppeeIcon={16}
                        />
                    );
                })}
            </>
        )
    );
};

export default ShowCartVisitWise;
